import type { FunctionComponent } from 'react'
import React from 'react'

import classNames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PlusMinusIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon
      aria-hidden={false}
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <rect
        className={(classNames(styles[className]), 'plusminus-vertical')}
        data-testid="icon-plusminus-vertical"
        fill={customColour}
        height="16"
        width="2"
        x="7"
      />
      <rect
        className={(classNames(styles[className]), 'plusminus-horizontal')}
        data-testid="icon-plusminus-horizontal"
        fill={customColour}
        height="2"
        width="16"
        y="7"
      />
    </Icon>
  )
}
